<template>
  <section>

    <b-row>
      <b-col md="12">
        <h2>Realizar Encuestas</h2>
      </b-col>
    </b-row>

    <b-overlay :show="show" rounded="sm" variant="white" class="mt-3">
      <b-row class="py-2">
        <b-col md="12">
          <b-form @submit.prevent="lanzarEncuesta">
            <b-row>
              <b-form-group label="Código:" label-for="input-codigo" class="col-6">
                <b-form-input id="input-codigo" v-model="form.codigo" type="text" required placeholder="Ingrese el código"></b-form-input>
              </b-form-group>
              <b-form-group label="Lanzar encuesta completa:" label-for="input-completa" class="col-6">
                <b-form-radio-group v-model="form.completa" name="completa">
                  <b-form-radio value="SI">Sí</b-form-radio>
                  <b-form-radio value="NO">No</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-row>
            <b-form-group label="Encuesta:" label-for="input-encuesta">
              <b-form-select id="input-encuesta" v-model="form.encuesta">
                <b-form-select-option :value="null">Caracterizacion (Original)</b-form-select-option>
                <b-form-select-option v-for="encuesta in encuestas" :key="encuesta.id" :value="encuesta.id">{{ encuesta.nombre }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-button type="submit" variant="primary">Realizar encuesta</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-overlay>
  </section>
</template>

<script lang="ts">
import axios from 'axios'
import { Vue, Component, Watch } from 'vue-property-decorator'

import { url } from '../../../services/url_service'

@Component
export default class LanzarEncuestas extends Vue {
  public show: boolean = false
  public form: any = {
    completa: 'NO',
    encuesta: null
  }
  public encuestas: Array<any> = []

  async lanzarEncuesta() {
    this.show = true
    try {
      let response = await axios.post(
        url.create('/internal/caracterizaciones/lanzar'),
        this.form
      )
      window.open(response.data.enlace, '_blank')
    } catch (error) {
      this.$bvToast.toast('No se encontró el código ingresado', {
        title: 'Error al crear el registro',
        variant: 'danger',
      })
    } finally {
      this.show = false
      this.form = {
        encuesta: null
      }
    }
  }

  public async cargarDinamicas() {
    let response = await axios.get(url.create('/internal/dinamicas'))
    this.encuestas = (response.data as Array<any>).filter(function (encuesta) {
      return encuesta.estado === 'ACTIVA'
    })
  }

  public created() {
    this.cargarDinamicas()
  }
}
</script>